// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("./../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-components-tablet-view-index-jsx": () => import("./../src/components/TabletView/index.jsx" /* webpackChunkName: "component---src-components-tablet-view-index-jsx" */),
  "component---src-components-404-index-jsx": () => import("./../src/components/404/index.jsx" /* webpackChunkName: "component---src-components-404-index-jsx" */)
}

